import { render, staticRenderFns } from "./simOpenTn.vue?vue&type=template&id=4f36c20b&scoped=true&"
import script from "./simOpenTn.vue?vue&type=script&lang=js&"
export * from "./simOpenTn.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTn.vue?vue&type=style&index=0&id=4f36c20b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36c20b",
  null
  
)

export default component.exports